import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export default function Spinner({ color }: { color?: string }) {
  return <Spin indicator={<LoadingOutlined style={{ fontSize: 20, color }} spin />} />;
}
